var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgBing = function SvgBing(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bing_svg__b)",
    fillRule: "evenodd",
    d: "M8.056 5.34a.591.591 0 0 0-.511.56c-.009.127-.006.135.273.874.634 1.68.787 2.085.813 2.142.063.138.15.268.26.384.085.09.14.137.235.202.165.114.248.146.891.342.627.191.97.318 1.265.47.383.195.65.417.818.68.121.19.229.53.275.872.018.133.019.428 0 .55a1.64 1.64 0 0 1-.238.665c-.064.098-.042.081.051-.038.264-.337.532-.913.669-1.436a4.462 4.462 0 0 0 .065-1.954c-.24-1.251-1.008-2.331-2.088-2.94a64.087 64.087 0 0 0-.838-.451 51.769 51.769 0 0 0-.502-.27 2863.185 2863.185 0 0 0-.659-.354c-.347-.187-.494-.263-.536-.276a.855.855 0 0 0-.184-.029l-.06.007Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bing_svg__c)",
    d: "M8.813 11.614a2.71 2.71 0 0 0-.128.081l-.516.328-.315.2a14.909 14.909 0 0 1-.308.196 102.016 102.016 0 0 1-.627.398l-.294.187a1.77 1.77 0 0 1-1.644.862c-.114.015-.33.015-.444 0a1.759 1.759 0 0 1-.836-.35 2.35 2.35 0 0 1-.344-.353 1.861 1.861 0 0 1-.321-.74 1.443 1.443 0 0 0-.027-.118c-.005-.006.004.09.021.213.017.13.054.317.093.476a3.95 3.95 0 0 0 3.402 2.99c.14.015.535.022.68.01.67-.052 1.252-.255 1.849-.643a218.476 218.476 0 0 1 .838-.546l.433-.281.149-.097.005-.004.017-.01.008-.005.109-.072.379-.246c.482-.312.626-.422.85-.648.093-.094.234-.255.241-.275.001-.004.027-.044.056-.089a1.64 1.64 0 0 0 .237-.663c.018-.12.018-.416 0-.55a2.863 2.863 0 0 0-.202-.737c-.142-.306-.444-.584-.878-.808a1.853 1.853 0 0 0-.257-.118c-.006 0-.41.255-.896.565a3120.37 3120.37 0 0 0-1.052.669l-.278.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bing_svg__d)",
    d: "m3.002 10.126.002 2.16.027.126a1.8 1.8 0 0 0 .488.937 1.686 1.686 0 0 0 1.24.528c.34 0 .635-.087.938-.278l.446-.283.353-.224V5.622c0-1.496-.003-2.384-.007-2.454a1.792 1.792 0 0 0-.506-1.145c-.092-.094-.17-.156-.404-.322l-.473-.335L4.58.992C4.434.89 4.226.742 4.118.664c-.226-.16-.244-.171-.312-.196a.6.6 0 0 0-.272-.035.603.603 0 0 0-.523.486C3.002.96 3 1.506 3 4.467v3.5H3l.002 2.16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bing_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.074 8.985 2.76) scale(7.94523 5.69057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#048FCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bing_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-23.814 36.17 -3.05) scale(8.48825 14.4335)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2756A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bing_svg__d",
    x1: 4.748,
    x2: 4.748,
    y1: 0.43,
    y2: 13.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2756A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBing);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;